import Arrow from "../../images/icons/whiteIcons/Arrow.svg";
import ArrowsClockwise from "../../images/icons/whiteIcons/ArrowsClockwise.svg";
import Buildings from "../../images/icons/whiteIcons/Buildings.svg";
import CalendarBlank from "../../images/icons/whiteIcons/CalendarBlank.svg";
import CheckSquare from "../../images/icons/whiteIcons/CheckSquare.svg";
import Clock from "../../images/icons/whiteIcons/Clock.svg";
import DownloadSimple from "../../images/icons/whiteIcons/DownloadSimple.svg";
import Eye from "../../images/icons/whiteIcons/Eye.svg";
import File from "../../images/icons/whiteIcons/File.svg";
import GlobeSimple from "../../images/icons/whiteIcons/GlobeSimple.svg";
import Home3 from "../../images/icons/whiteIcons/Home 3.svg";
import MagnifyingGlass from "../../images/icons/whiteIcons/MagnifyingGlass.svg";
import MailSendEnvelope from "../../images/icons/whiteIcons/Mail Send Envelope.svg";
import MapPin from "../../images/icons/whiteIcons/MapPin.svg";
import PhoneMobilePhone from "../../images/icons/whiteIcons/Phone Mobile Phone.svg";
import SealCheck from "../../images/icons/whiteIcons/SealCheck.svg";
import SlidersHorizontal from "../../images/icons/whiteIcons/SlidersHorizontal.svg";
import X from "../../images/icons/whiteIcons/X.svg";
import fluentSend16Filled from "../../images/icons/whiteIcons/fluent_send-16-filled.svg";
import ionArrowUpSharp from "../../images/icons/whiteIcons/ion_arrow-up-sharp.svg";
import materialSymbolsCookieOutline from "../../images/icons/whiteIcons/material-symbols_cookie-outline.svg";
import phSmileySadLight from "../../images/icons/whiteIcons/ph_smiley-sad-light.svg";

export const colorsVariants = [
  {
    name: "White",
    hex: "#FFFFFF",
  },
  {
    name: "Grey",
    hex: "#E9ECED",
  },
  {
    name: "Toxic Green",
    hex: "#00FF00",
  },
  {
    name: "Emerald",
    hex: "#035C67",
  },
  {
    name: "Dark Grey",
    hex: "#2F3133",
  },
  {
    name: "Black",
    hex: "#121517",
  },
  {
    name: "Grey Hover",
    hex: "#F4F5F6",
  },
  {
    name: "Light Green",
    hex: "#BEF4BE",
  },
  {
    name: "Light Green Hover",
    hex: "#A7F2A7",
  },
  {
    name: "Green White Gradient",
    hex: "linear-gradient(90deg, #FFFFFF 0%, #00FF00 100%)",
  },
  {
    name: "Green Emerald Gradient",
    hex: "linear-gradient(90deg, #19636B 0%, #00FF00 100%)",
  },
  {
    name: "Green linear Gradient",
    hex: "linear-gradient(180deg, rgba(25, 99, 107, 0.00) 40%, rgba(0, 255, 0, 0.70) 100%)",
  },
  {
    name: "Red",
    hex: "#FF4E4E",
  },
  {
    name: "Yellow",
    hex: "#FFDB1B",
  },
  {
    name: "White Secondary 12",
    hex: "#FFFFFF1F",
  },
  {
    name: "White Secondary 20",
    hex: "#FFFFFF33",
  },
  {
    name: "White Secondary 50",
    hex: "#FFFFFF80",
  },
  {
    name: "Emerald Secondary 10",
    hex: "#035C671A",
  },
  {
    name: "Emerald Secondary 20",
    hex: "#035C6733",
  },
  {
    name: "Black Secondary 10",
    hex: "#1215161A",
  },
  {
    name: "Black Secondary 30",
    hex: "#1215164D",
  },
];
export const whiteIcons = [
  {
    image: Arrow,
    alt: "Arrow",
  },
  {
    image: ArrowsClockwise,
    alt: "ArrowsClockwise",
  },
  {
    image: Buildings,
    alt: "Buildings",
  },
  {
    image: CalendarBlank,
    alt: "CalendarBlank",
  },
  {
    image: CheckSquare,
    alt: "CheckSquare",
  },
  {
    image: Clock,
    alt: "Clock",
  },
  {
    image: DownloadSimple,
    alt: "DownloadSimple",
  },
  {
    image: Eye,
    alt: "Eye",
  },
  {
    image: File,
    alt: "File",
  },
  {
    image: GlobeSimple,
    alt: "GlobeSimple",
  },
  {
    image: Home3,
    alt: "Home3",
  },
  {
    image: MagnifyingGlass,
    alt: "MagnifyingGlass",
  },
  {
    image: MailSendEnvelope,
    alt: "MailSendEnvelope",
  },
  {
    image: MapPin,
    alt: "MapPin",
  },
  {
    image: PhoneMobilePhone,
    alt: "PhoneMobilePhone",
  },
  {
    image: SealCheck,
    alt: "SealCheck",
  },
  {
    image: SlidersHorizontal,
    alt: "SlidersHorizontal",
  },
  {
    image: X,
    alt: "X",
  },
  {
    image: fluentSend16Filled,
    alt: "fluentSend16Filled",
  },
  {
    image: ionArrowUpSharp,
    alt: "ionArrowUpSharp",
  },
  {
    image: materialSymbolsCookieOutline,
    alt: "materialSymbolsCookieOutline",
  },
  {
    image: phSmileySadLight,
    alt: "phSmileySadLight",
  },
];

export const dropdownArray = [
  { name: "Customer" },
  { name: "Partner" },
  { name: "Employee" },
  { name: "Other" },
];
